import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { IAppState } from "../store/states/app";
import { BootAttempt } from "../store/actions/boot";
import { selectAppBootState } from "../store/selectors";
import { merge, of, fromEvent } from "rxjs";
import { mapTo } from "rxjs/operators";
import { Online } from "../store/actions/connection";

@Injectable({
  providedIn: "root",
})
export class InternetConnectionService {
  constructor(private _store: Store<IAppState>) {}
  load() {
    const online = merge(
      of(navigator.onLine),
      fromEvent(window, "online").pipe(mapTo(true)),
      fromEvent(window, "offline").pipe(mapTo(false)),
    );
    online.subscribe((val) => {
      this._store.dispatch(new Online({ connected: val }));
    });
  }
}
